<template>
  <div class="header-user-type" v-if="isCheckoutAsClient">
    <UserType reload-page />
    <UserSelectedShop v-if="isManager" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserType from '@/components/header/user-type/UserType'
import UserSelectedShop from '@/components/header/user-type/UserSelectedShop'

export default {
  name: 'HeaderUserType',
  components: {
    UserType,
    UserSelectedShop
  },
  computed: {
    ...mapGetters(['isCheckoutAsClient', 'isManager'])
  }
}
</script>

<style scoped lang="sass">
.header-user-type
  width: 100%
</style>
